import React, { useState } from 'react'
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import data from './data.json';
function Nostra() {
    const arr = [0,0,0,0,0,0];
    const [scores,setScores] = useState(arr);
    const handleOnChange = (e,idx)=>{
        let na = [...scores];
        na[idx] = Number(e.target.value);
        setScores(na);
    }
    const eachInput = (ip,idx1)=>{
        const arr = Object.keys(data[`${ip}`]);
        return <FormGroup>
        <Label for="exampleSelectMulti">{ip.toUpperCase()}</Label>
        <Input onChange={(e)=>{handleOnChange(e,idx1)}} type="select" name="selectMulti" id="exampleSelectMulti" >
            <>
             <option value='' hidden>Select {ip}</option>  
              {arr.map((el,idx)=>{
                  return (
                    <option key={idx} value={Number(data[`${ip}`][`${el}`])}>{el.toUpperCase()}</option>
                  )
              })
            }
              </>
            
        </Input>
      </FormGroup>
    }
    return (
        <div className='py-5' style={{width:'60%',margin:'auto'}}>
            <h1 className='mt-5 mb-5'>Nomstronaut</h1>
         {
             Object.keys(data).map((el,idx)=>{
                return (<div key={idx}>
                 {
                     eachInput(el,idx)
                 }
                 </div>)
             })
         }
         <h4 className='mt-5'>Your Rarity Score is {scores.reduce((prev,curr)=>prev+curr).toFixed(2)}</h4>
         <h6>In general on the calculator, a lower rarity score is better</h6>
        </div>
    )
}

export default Nostra
